import styled from 'styled-components'
import Card from '@material-ui/core/Card'

export const CardMaterialEx = styled(Card)`
  ${(props) =>
    props.width &&
    `
    width: ${props.width}px !important;
    max-width: ${props.width}px !important;
  `}

  @media (min-width: 320px) and (orientation: portrait) {
    width: 100% !important;
  }

  @media (min-width: 375px) and (max-height: 667px) and (orientation: portrait) {
    width: 100% !important;
  }

  @media (min-width: 414px) and (max-height: 736px) and (orientation: portrait) {
    width: 100% !important;
  }

  @media (min-width: 375px) and (max-width: 812px) and (orientation: portrait) {
    width: 100% !important;
  }

  @media (min-width: 320px) and (orientation: portrait) {
    width: 100% !important;
  }
`



// WEBPACK FOOTER //
// ./src/material.style.js